<a mat-ripple class="menu-item" [class.active]="isActive()" [attr.data-text]="item().label" uiNavLink [link]="item()">
  <div [class]="levelClass()">
    <div class="left">{{ item().label }}</div>
    <div class="right">{{ item().badgeCount }}</div>
  </div>
</a>

